import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import companyReducer from 'modules/Company/Company.reducer';
import contactReducer from 'modules/Contact/Contact.reducer';
import dealApi from 'modules/Deal/api/deal';
import dispatchApi from 'modules/Event/api/dispatching';
import dispatching from 'modules/Event/slices/dispatching';
import offices from 'modules/Office/api/office';
import eventReducer from 'modules/EventLog/Events.reducer';
import statusReducer from 'modules/EventLog/Events.Status.reducer';
import newInvoice from 'modules/NewInvoice/NewIncoiceForm.reducer';
import scheduler from 'modules/Scheduler/Scheduler.reducer';
import serviceCallApi from 'modules/ServiceCall/api/serviceCall';
import serviceCallReducer from 'modules/ServiceCall/ServiceCall.reducer';
import siteReducer from 'modules/Site/Site.reducer';
import taskApi from 'modules/Task/api/task';
import taskReducer from 'modules/Task/Task.reducer';
import bgReducer from 'store/BackgroundCheck/reducer';
import brandReducer from 'store/Brand/brandReducer';
import clientReducer from 'store/Client/clientreducer';
import commonReducer from 'store/common/commonreducer';
import dealReducer from 'store/Deal/dealReducer';
import inventoryReducer from 'store/Inventory/inventoryReducer';
import invoiceReducer from 'store/Invoice/invoiceReduce';
import loginReducer from 'store/Login/loginReducer';
import newPaymentReducer from 'store/NewPayments/reducer';
import notesReducer from 'store/Notes/reducer';
import pkgReducer from 'store/Packages/reducer';
import productReducer from 'store/Product/productReducer';
import reducer from 'store/reducer';
import realtimeNotificationsReducer from 'modules/Notifications/state/realtimeNotificationsSlice';
import serviceReducer from 'store/Service/serviceReducer';
import subscriptionReducer from 'store/Subscriptions/subscriptionReducer';
import userReducer from 'store/User/userReducer';
import newDealReducer from './NewDeal/newDealReducer';

const persistConfig = {
  key: 'root',
  storage,
};

export default combineReducers({
  reducer,
  common: commonReducer,
  login: persistReducer(persistConfig, loginReducer),
  client: clientReducer,
  product: productReducer,
  site: siteReducer,
  company: companyReducer,
  contact: contactReducer,
  user: userReducer,
  inventory: inventoryReducer,
  deal: dealReducer,
  newDeal: newDealReducer,
  brand: brandReducer,
  bgCheck: bgReducer,
  serviceCall: serviceCallReducer,
  service: serviceReducer,
  subscription: subscriptionReducer,
  notes: notesReducer,
  task: taskReducer,
  packages: pkgReducer,
  payment: newPaymentReducer,
  invoice: invoiceReducer,
  scheduler,
  event: eventReducer,
  eventStatuses: statusReducer,
  newInvoice,
  dispatching: dispatching.reducer,
  dispatchingApi: dispatchApi.reducer,
  serviceCallApi: serviceCallApi.reducer,
  taskApi: taskApi.reducer,
  dealApi: dealApi.reducer,
  realtimeNotifications: realtimeNotificationsReducer,
  [offices.reducerPath]: offices.reducer,
});